import { Button, Flex, FormControl, Grid, Input, Spinner, Text, useToast } from "@chakra-ui/react"

import Card from "components/Card/Card"
import CardHeader from "components/Card/CardHeader"
import CardBody from "components/Card/CardBody"
import { useEffect, useState } from "react"
import { RESET_PASSWORD, VALIDATE_RESET_TOKEN } from "services/auth"
import { useDispatch } from "react-redux"
import { bindActionCreators } from "redux"
import { authCreator } from "state/index"
import { useNavigate, useParams } from "react-router-dom"
import { split } from "lodash"

interface FormData {
    password: string,
    confirmPassword: string
}

const initialState = {
    password: '',
    confirmPassword: ''
}

const ResetPassword = () => {
    const splitUrl = window.location.href.split("/");
    const resetToken = splitUrl[splitUrl.length - 1];


    const [userId, setUserId] = useState<string>("");
    const [data, setData] = useState<FormData>(initialState);
    const [loading, setLoading] = useState<boolean>(true);
    const [invalid, setInvalid] = useState<boolean>(false);
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

    const toast = useToast()

    useEffect(() => {
        const validateToken = async () => {
            setLoading(true);
            try {
                const response = await VALIDATE_RESET_TOKEN({
                    token: resetToken
                });
                setUserId(response.user_id);

            } catch (err) {
                console.error(err);
                toast({
                    title: `Link inválido`,
                    duration: 4000,
                    position: "bottom",
                    status: "error"
                })
            } finally {
                setLoading(false);
            }
        }
        validateToken();
    }, [])

    const onSubmit = async () => {
        setLoadingSubmit(true);
        try {
            const response = await RESET_PASSWORD({
                ...data,
                user_id: userId,
                token: resetToken
            });

            toast({
                title: `Senha cadastrada com sucesso`,
                duration: 4000,
                position: "bottom",
                status: "success"
            })

            setTimeout(() => {
                window.location.href = '../..';
            }, 2000)
        } catch (err) {
            console.error(err);

            toast({
                title: "Não foi possível alterar sua senha",
                duration: 4000,
                position: "bottom",
                status: "error"
            })
        } finally {
            setLoadingSubmit(false);
        }
    }

    return (
        <Flex w="full" minH="100vh" justifyContent="center" alignItems="center">
            <Card maxW="420px" minH="460px">
                <CardHeader minH="80px" justifyContent="center" alignItems="center">
                    Nova Senha
                </CardHeader>
                <CardBody mt="auto" mb="auto">
                    <Flex flexDirection="column" w="full">
                        {
                            loading ?
                                <Spinner size="lg" />
                                :
                                <>
                                    <Grid
                                        w="full"
                                        templateColumns="repeat(1, 1fr)"
                                        templateRows="repeat(2, 1fr)"
                                        gap="16px"
                                        mb="4"
                                    >
                                        <FormControl>
                                            <Input
                                                value={data.password}
                                                onChange={({ target }) => setData({ ...data, password: target.value })}
                                                disabled={loadingSubmit}
                                                placeholder="Nova Senha"
                                                type="password"
                                                borderRadius="8px"
                                                fontSize="md"
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <Input
                                                value={data.confirmPassword}
                                                onChange={({ target }) => setData({ ...data, confirmPassword: target.value })}
                                                disabled={loadingSubmit}
                                                placeholder="Confirma Senha"
                                                type="password"
                                                borderRadius="8px"
                                                fontSize="md"
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Flex w="full" mb="2">
                                        <Button
                                            isLoading={loadingSubmit}
                                            disabled={loadingSubmit}
                                            w="full"
                                            colorScheme="green"
                                            onClick={onSubmit}
                                        >Enviar</Button>
                                    </Flex>
                                </>
                        }
                        {/* <Flex w="full">
                            <Text fontSize="14">Problemas com login</Text>
                        </Flex> */}
                    </Flex>
                </CardBody>
            </Card>
        </Flex>
    )
}

export default ResetPassword